import { mainApi } from '../utils/api';

export type UpdateUserInput = {
  id: number;
  data: {
    first_name?: string;
    last_name?: string;
    profile_pic?: File;
  };
};

export type ActivateUserInput = {
  userId: number;
  data: {
    first_name: string;
    last_name: string;
    profile_pic: File;
  };
};

const updateUser = ({ id, data }: UpdateUserInput) =>
  mainApi.patch(`users/${id}/`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

const getUserById = (id: number) => mainApi.get(`users/${id}/`);

const activateUser = ({ userId, data }: ActivateUserInput) =>
  mainApi.post(`users/${userId}/activate/`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export { updateUser, getUserById, activateUser };
